"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNestable = _interopRequireDefault(require("react-nestable"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faGripLines = require("@fortawesome/pro-regular-svg-icons/faGripLines");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SortableRow = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: grab;\n    background-color: #666;\n    border-bottom: 1px solid;\n    padding: 10px 15px;\n    border-radius: 3px;\n\n    &:last-child {\n        border-bottom: none;\n    }\n\n    &:active {\n        cursor: grabbing;\n        background-color: #888;\n    }\n"])));

var ListItem = function ListItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/_react["default"].createElement(SortableRow, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faGripLines.faGripLines,
    className: "mr-2"
  }), " ", item.label);
};

var AccordionItemSort = function AccordionItemSort(_ref2) {
  var accordion = _ref2.accordion,
      _onChange = _ref2.onChange;
  var accordionItems = accordion.map(function (acc, idx) {
    return _objectSpread(_objectSpread({}, acc), {}, {
      id: idx
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_reactNestable["default"], {
    items: accordionItems,
    renderItem: ListItem,
    onChange: function onChange(items) {
      return _onChange({
        accordion: items
      });
    },
    maxDepth: 1
  });
};

var _default = AccordionItemSort;
exports["default"] = _default;